<template>
  <div class="contractor-page">
    <h1>Contractor Information</h1>

    <div v-if="loading">Loading contractor data...</div>

    <div v-else>
      <!-- View Mode -->
      <div v-if="!editMode">
        <p><strong>Name:</strong> {{ contractor.name }}</p>
        <p><strong>Email:</strong> {{ contractor.email }}</p>
        <p><strong>Phone:</strong> {{ contractor.phone }}</p>
        <!-- Add more fields as needed -->

        <button @click="enterEditMode">Edit Contractor</button>
        <button @click="handleDelete">Delete Contractor</button>
      </div>

      <!-- Edit Mode -->
      <div v-else>
        <form @submit.prevent="handleUpdate">
          <div>
            <label for="name">Name:</label>
            <input type="text" id="name" v-model="editedContractor.name" required />
          </div>
          <div>
            <label for="email">Email:</label>
            <input type="email" id="email" v-model="editedContractor.email" />
          </div>
          <div>
            <label for="phone">Phone:</label>
            <input type="text" id="phone" v-model="editedContractor.phone" />
          </div>
          <!-- Add additional fields as needed -->

          <button type="submit">Save</button>
          <button type="button" @click="cancelEdit">Cancel</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const loading = ref(true);
const editMode = ref(false);
const editedContractor = ref({
  name: '',
  email: '',
  phone: ''
});

// Assume you have a Vuex state or getter that holds the contractor data
const contractor = computed(() => store.state.contractor);

// Fetch contractor data when the component mounts
onMounted(async () => {
  try {
    await store.dispatch('fetchContractor');
  } catch (error) {
    console.error('Error fetching contractor data:', error);
  } finally {
    loading.value = false;
  }
});

// Enter edit mode and pre-populate the form with current contractor info
function enterEditMode() {
  editMode.value = true;
  editedContractor.value = { ...contractor.value };
}

// Cancel edit mode
function cancelEdit() {
  editMode.value = false;
}

// Handle form submission to update contractor data
async function handleUpdate() {
  try {
    await store.dispatch('updateContractor', editedContractor.value);
    editMode.value = false;
  } catch (error) {
    console.error('Error updating contractor:', error);
  }
}

// Handle contractor deletion
async function handleDelete() {
  if (confirm('Are you sure you want to delete this contractor?')) {
    try {
      await store.dispatch('deleteContractor', contractor.value._id);
    } catch (error) {
      console.error('Error deleting contractor:', error);
    }
  }
}
</script>

<style scoped>
.contractor-page {
  max-width: 600px;
  margin: 0 auto;
  padding: 1rem;
}

.contractor-page h1 {
  text-align: center;
  margin-bottom: 1rem;
}

.contractor-page p {
  font-size: 1.1rem;
}

.contractor-page label {
  display: block;
  margin-top: 0.5rem;
}

.contractor-page input {
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
}

.contractor-page button {
  margin-right: 0.5rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
}
</style>
